import React from 'react'
import { Formik, Field } from 'formik'

// Components
import Button from '../../components/Button'


// Constants
import { FORM_FIELDS } from './constants'

const Form = () => {
  return (
    <Formik
      onSubmit={(values, actions) => {
        fetch(' https://ka0segh4df.execute-api.ap-south-1.amazonaws.com/prod/contact', {
          method: 'POST', // or 'PUT'
          body: JSON.stringify({
            name: values.name,
            email: values.email,
            address: values.address,
            company: values.company,
            title: values.title || '-',
            phone: values.phone,
            inquiry: values.inquiry,
          }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data) {
              window.location.reload()
              alert('Something went wrong. Please try again later');
            } else { // meaning - success
              window.location.reload()
              alert('Thank you for your interest. We will get back to you shortly.');
            }
          })
          .catch((error) => {
            window.location.reload()
            alert('Something went wrong. Please try again later');
          });
      }}
      render={(props) => {
        return (
          <form onSubmit={props.handleSubmit}>
            {
              FORM_FIELDS.map((item, i) => {
                return (
                  <div key={`formFields${i}`}>
                    <label className="c-padd" style={{ paddingBottom: 0 }}>{item.title}</label>
                    <div className="c-padd">
                      <Field
                        // className={props.errors.name && 'error'}
                        validate={item.validation}
                        name={item.name}
                        component={item.component}
                        type="text"
                        placeholder={item.placeholder}
                      />
                    </div>
                    {(props.touched[item.name] || props.errors[item.name]) && <label className="e-label c-padd error">{props.errors[item.name]}</label>}
                  </div>
                )
              })
            }

            <div className="c-padd">
              <Button
                title="Submit"
                type="submit"
              />
            </div>
          </form>
        )
      }}
    />
  )
}

export default Form